import {DodgerBlueColor} from '../../cmsMainStyle'

const docSubCreateFormStyle = theme => ({

	submissinTypeRoot: {
		'& .MuiTextField-root': {
			marginTop: theme.spacing(0),
		},
		backgroundColor: DodgerBlueColor[0]
	},

	// fieldRoot: {
	// 	'& .MuiTextField-root': {
	// 		marginTop: theme.spacing(2),
	// 	},
	// },

	fieldDivision: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 320),
		overflowY: "auto",
		overflowX: "hidden",
		paddingTop: theme.spacing(2)
	},

	buttonMenu: {
		'& > *': {
			marginRight: theme.spacing(1),
		},
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(1),
	},

	marginSpace: {
		marginTop: theme.spacing(2),
	},

	divider: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(2),
	},

	datePickerField: {
		// marginBottom: theme.spacing(0),
		width: '100%',
	},


	receiptSubject: {
		fontSize: "25px",
		fontWeight: "bold",
		textDecoration: "underline",
		marginBottom: theme.spacing(3),
	},

	receiptTitle: {
		fontSize: "20px",
		fontWeight: "bold",
		// marginBottom: theme.spacing(1),
	},

	receiptContent: {
		fontSize: "20px",
		marginBottom: theme.spacing(3),
	},

	checkboxArea: {
		marginTop: theme.spacing(2),
		paddingLeft: theme.spacing(1.5),
		paddingRight: theme.spacing(1.5),
	},

	requireErrorMsg: {
		marginTop: theme.spacing(0.5),
		marginLeft: theme.spacing(2)
	}




})

export {docSubCreateFormStyle}